export const DEFAULT_DOCK_PANEL_HEIGHT = 64;
export const DEFAULT_DOCK_HEIGHT = 256;
export const DEFAULT_DOCK_BASE_ITEM_SIZE = 50;
export const DEFAULT_DOCK_MAGNIFICATION = 70;
export const DEFAULT_DOCK_DISTANCE = 200;
export const DOCK_VIEWPORT_OFFSET_PX = 8;
export const DOCK_PANEL_BOTTOM_PADDING_PX = 8;
export const DOCK_PANEL_HORIZONTAL_PADDING_PX = 16;
export const DOCK_ITEM_GAP_PX = 16;
export const DOCK_SPRING = { mass: 0.1, stiffness: 150, damping: 12 } as const;
export const DOCK_Z_INDEX = 1390;
export const DEFAULT_DOCK_VISIBLE = true;
export const DOCK_CONTENT_CLEARANCE_PX =
  DEFAULT_DOCK_PANEL_HEIGHT +
  DOCK_PANEL_BOTTOM_PADDING_PX +
  DOCK_VIEWPORT_OFFSET_PX * 2;

export enum DOCK_POSITION {
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export const DOCK_POSITION_OPTIONS = [
  DOCK_POSITION.BOTTOM_CENTER,
  DOCK_POSITION.BOTTOM_RIGHT,
];

export const DEFAULT_DOCK_POSITION = DOCK_POSITION.BOTTOM_CENTER;
